export const formatDate = (date) => {
  return new Date(date).toISOString().split('T')[0]
}

export const formatDateTime = (date) => {
    const d = new Date(date);

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');

    let hours = d.getHours();
    const minutes = String(d.getMinutes()).padStart(2, '0');

    const ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12 || 12;

    return `${year}-${month}-${day} ${String(hours).padStart(2, '0')}:${minutes}${ampm}`;
};